import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { safeJSONParse } from '../utility/json'
import { logger } from '../utility/logger'

export default defineNuxtRouteMiddleware((to) => {
  if (process.server && to.query.bounds) {
    const { path, query, hash } = to
    const bounds = safeJSONParse(query.bounds as string)

    // If bounds are in old format, convert them
    if (bounds && isOldBoundsFormat(bounds)) {
      const { north, south, east, west } = bounds as Record<string, number>
      const redirectQuery = {
        ...query,
        bounds: JSON.stringify({
          northEast: { lat: north, lng: east },
          southWest: { lat: south, lng: west },
        }),
      }
      return navigateTo(
        { path, query: redirectQuery, hash },
        { redirectCode: 301 },
      )
    }

    // If bounds param exists but is invalid/incomplete, remove it
    if (!isValidBounds(bounds)) {
      logger('updateBoundsParams.global: invalid bounds', query.bounds)
      const redirectQuery = { ...query }
      delete redirectQuery.bounds
      return navigateTo(
        { path, query: redirectQuery, hash },
        { redirectCode: 301 },
      )
    }
  }
})

function isOldBoundsFormat(bounds: unknown): bounds is Record<string, number> {
  if (typeof bounds !== 'object' || bounds === null) {
    return false
  }
  const { north, south, east, west } = bounds as Record<string, any>
  return (
    typeof north === 'number' &&
    typeof south === 'number' &&
    typeof east === 'number' &&
    typeof west === 'number'
  )
}

function isValidBounds(bounds: unknown): bounds is Record<string, any> {
  if (typeof bounds !== 'object' || bounds === null) {
    return false
  }
  const { northEast, southWest } = bounds as Record<string, any>
  return (
    typeof northEast === 'object' &&
    typeof southWest === 'object' &&
    typeof northEast.lat === 'number' &&
    typeof northEast.lng === 'number' &&
    typeof southWest.lat === 'number' &&
    typeof southWest.lng === 'number'
  )
}
